import { render, staticRenderFns } from "./inputTextNumbers.pug?vue&type=template&id=1d452c2a&lang=pug&external"
import script from "./inputTextNumbers.js?vue&type=script&lang=js&external"
export * from "./inputTextNumbers.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d452c2a')) {
      api.createRecord('1d452c2a', component.options)
    } else {
      api.reload('1d452c2a', component.options)
    }
    module.hot.accept("./inputTextNumbers.pug?vue&type=template&id=1d452c2a&lang=pug&external", function () {
      api.rerender('1d452c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/text-numbers/index.vue"
export default component.exports